import React from 'react';
import { Tooltip } from '@mui/material';
import { Help } from '@mui/icons-material';

const definitions = () => (
  <span>
    The sampling rate measures the time between readings for all the sensors that Onboard monitors.
    It is often impacted by the type of sensor being monitored and the network latency. For example:
    power meters are often sampled every thirty seconds, and temperature sensors are sampled every
    five minutes.
    <br />
    <br />
    The data age measures the time between right now and the latest reading we have collected from
    every sensor. This metric is designed to answer the question: “How recent is my data?”
  </span>
);

const DataTermsInfo = () => (
  <div className="dq-terms-info">
    <Tooltip title={definitions()} enterDelay={0}>
      <Help style={{ color: 'rgba(0, 0, 0, 0.2)' }} />
    </Tooltip>
  </div>
);

export default DataTermsInfo;
